export async function rest_client(url_for_fetch = ""){
    const response = await fetch(url_for_fetch)
    const result = await response.json()
  
    return result
  }